module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('Kanban', {
    attrs: {
      "stages": _vm.statuses,
      "blocks": _vm.blocks
    },
    on: {
      "update-block": _vm.updateBlock
    }
  }, [_vm._l((_vm.statuses), function(stage) {
    return _c('div', {
      key: stage,
      slot: stage
    }, [_c('h2', [_vm._v("\n        " + _vm._s(stage) + "\n        "), _c('a', [_vm._v("+")])])])
  }), _vm._v(" "), _vm._l((_vm.blocks), function(item) {
    return _c('div', {
      key: item.id,
      slot: item.id
    }, [_c('div', [_c('strong', [_vm._v("id:")]), _vm._v(" " + _vm._s(item.id) + "\n      ")]), _vm._v(" "), _c('div', [_vm._v("\n        " + _vm._s(item.title) + "\n      ")])])
  }), _vm._v(" "), _vm._l((_vm.statuses), function(stage) {
    return _c('div', {
      key: stage,
      slot: ("footer-" + stage)
    }, [_c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          (function () { return _vm.addBlock(stage); })($event)
        }
      }
    }, [_vm._v("+ Add new block")])])
  })], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h4', [_vm._v("\n      Vue adoptation of Ettric's\n      "), _c('a', {
    attrs: {
      "href": "//codepen.io/ettrics/pen/QbPEeg"
    }
  }, [_vm._v("Codepen")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1117
// module chunks = 1